import { EApiKey, PUBLIC_SEARCH_PREFIX } from '@/publicSearch/constants';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import type { NewsFeedItem } from '@/app/api/publicSearch/newsfeed/route';

const url = `${PUBLIC_SEARCH_PREFIX}/newsfeed`;

// Parsing happens server-side (see api/publicSearch/newsfeed/route.ts) so
// the client doesn't have to ship `rss-parser` + sax + stream-http polyfills.
export function useNewsFeed() {
  const [debouncedIsLoading, setDebouncedIsLoading] = useState(true);

  const queryFeed = useSWR<NewsFeedItem[]>(EApiKey.GET_NEWS_FEED, async () => {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`News feed request failed: ${response.status}`);
    }
    return response.json();
  });

  // hides loading artefacts
  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (!queryFeed.isLoading && !queryFeed.isValidating) {
      timeout = setTimeout(() => setDebouncedIsLoading(false), 500);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [queryFeed.isLoading, queryFeed.isValidating]);

  return {
    ...queryFeed,
    isLoading: debouncedIsLoading,
  };
}
